import { render, staticRenderFns } from "./DelayedProgress.vue?vue&type=template&id=4fbbf02f&"
import script from "./DelayedProgress.vue?vue&type=script&lang=ts&"
export * from "./DelayedProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbbf02f')) {
      api.createRecord('4fbbf02f', component.options)
    } else {
      api.reload('4fbbf02f', component.options)
    }
    module.hot.accept("./DelayedProgress.vue?vue&type=template&id=4fbbf02f&", function () {
      api.rerender('4fbbf02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelayedProgress.vue"
export default component.exports